import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "contents", "children", "className", "breakpoint"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styled from "styled-components";
import { extendedSystemStyles, extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "grid"];
var StyledGrid = styled.ol.withConfig({
  displayName: "R1CX_1__StyledGrid",
  componentId: "sc-f4lz5m-0"
})(["display:grid;", " overflow-x:auto;overflow-y:hidden;& > li{min-width:400px;max-width:500px;}&::-webkit-scrollbar{width:0;height:0;}"], extendedSystemStyles(styledSystemKeys));
export default function R1CX_1(_ref) {
  var id = _ref.id,
    contents = _ref.contents,
    children = _ref.children,
    className = _ref.className,
    breakpoint = _ref.breakpoint,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledGrid, _objectSpread(_objectSpread({
    id: id,
    gridTemplateColumns: "repeat(".concat(contents.length, ", 1fr)"),
    breakpoint: breakpoint,
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, rest)), {}, {
    children: children
  }));
}